import React, { useEffect, useRef, useState, useCallback } from 'react';
import PropTypes from 'prop-types';
import * as Styles from './sign-up-requirements-modal.module.scss';
import { useAuth } from '../contexts/AuthContext';
import SignUpRequirementsSsoUser from './sign-up-requirements-sso-user';
import SignUpRequirementsPasswordUser from './sign-up-requirements-password-user';

function SignUpRequirementsModal({ show }) {
  const dialog = useRef(null);
  const [animate, setAnimate] = useState('');
  const { isPasswordUser, isGoogleUser, isCleverUser } = useAuth();

  useEffect(() => {
    if (dialog.current && show) {
      setAnimate('enter');
      dialog.current.showModal();
    } else if (dialog.current && !show) {
      setAnimate('exit');
    }
  }, [dialog, show]);

  function handleDialogAnimateEnd() {
    if (animate === 'exit') {
      dialog.current.close();
    }
  }

  function handleDialogKeyPress(e) {
    if (e.key === 'Escape') {
      e.preventDefault();
    }
  }

  const scrollToTop = useCallback(() => {
    if (dialog.current) {
      dialog.current.scrollTo(0, 0, { behavior: 'smooth' });
    }
  }, [dialog]);

  return (
    <div>
      {/* eslint-disable-next-line jsx-a11y/no-noninteractive-element-interactions */}
      <dialog
        ref={dialog}
        onKeyDown={handleDialogKeyPress}
        className={Styles.dialog}
        onAnimationEnd={handleDialogAnimateEnd}
        data-animate={animate}
      >
        <div className={Styles.title}>Please complete your profile</div>
        {isPasswordUser && <SignUpRequirementsPasswordUser scrollToTop={scrollToTop} />}
        {isGoogleUser && <SignUpRequirementsSsoUser scrollToTop={scrollToTop} />}
        {isCleverUser && <SignUpRequirementsSsoUser scrollToTop={scrollToTop} />}
      </dialog>
    </div>
  );
}

SignUpRequirementsModal.propTypes = {
  show: PropTypes.bool.isRequired,
};

export default SignUpRequirementsModal;
